addObservableQueryPromise